
























































import { defineComponent, PropType, ref } from '@nuxtjs/composition-api'
import { computed } from '@vue/composition-api'
import InputError from '@/components/Inputs/new-design/InputError.vue'

export default defineComponent({
  name: 'InputFile',
  components: { InputError },
  props: {
    value: {
      type: Array as PropType<File[]>,
      default: () => [],
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: '',
    },
    labelDescription: {
      type: String,
      default: '',
    },
    accept: {
      type: String,
      default: '',
    },
    formats: {
      type: Array as PropType<string[]>,
      default: () => [],
    },
    maxSize: {
      type: Number,
      default: 10,
    },
    maxCount: {
      type: Number,
      default: 100,
    },
    error: {
      type: [String, Boolean],
      default: '',
    },
  },
  setup(props, { emit }) {
    const files = ref<File[]>(props.value)
    const dragover = ref<boolean>(false)
    const isFocus = ref<boolean>(false)

    const isMaxCountLimitExceeded = computed(
      () => files.value?.length > props.maxCount
    )

    const isLimitSize = () => {
      return (
        props.maxSize * 1024 * 1024 <
        files.value.reduce((acc, current) => current.size + acc, 0)
      )
    }

    const checkFormat = (file) => {
      if (!props.formats.length) return true
      return props.formats.includes(
        /(?:\.([^.]+))?$/.exec(file.name)?.[1]?.toLowerCase()
      )
    }

    const onInput = (event: InputEvent) => {
      const target = event.target as HTMLInputElement
      if (!target.files.length) return
      files.value = [...target.files, ...files.value]

      if (files.value.length > 1) {
        const wrongFormatFiles = files.value.filter(
          (file) => !checkFormat(file)
        )
        if (isMaxCountLimitExceeded.value) {
          emit('limit-count')
        }
        if (isLimitSize()) {
          // files.value = []
          // target.files = new DataTransfer().files
          emit('limit-size')
        } else if (wrongFormatFiles.length) {
          files.value = files.value.filter(checkFormat)
          const dt = new DataTransfer()
          files.value.forEach((file) => {
            dt.items.add(file)
          })
          target.files = dt.files
          emit('wrong-format', wrongFormatFiles)
        }
      }

      emit('input', files.value)
    }

    const filesToDisplay = computed(() => {
      // if (isLimitSize()) {
      //   return []
      // }
      return files.value.filter(checkFormat)
    })

    const onDragOver = (e: DragEvent) => {
      e.preventDefault()
      dragover.value = true
    }

    const onDragLeave = (e: DragEvent) => {
      e.preventDefault()
      dragover.value = false
    }

    const onDrop = (e: DragEvent) => {
      e.preventDefault()
      if (!Array.from(e.dataTransfer.files).length) return

      files.value = [...Array.from(e.dataTransfer.files), ...files.value]

      if (files.value.length > 1) {
        const wrongFormatFiles = files.value.filter(
          (file) => !checkFormat(file)
        )
        if (isMaxCountLimitExceeded.value) {
          emit('limit-count')
        }
        if (isLimitSize()) {
          // files.value = []
          // e.dataTransfer.clearData()
          emit('limit-size')
        } else if (wrongFormatFiles.length) {
          files.value = files.value.filter(checkFormat)
          files.value.forEach((file) => {
            e.dataTransfer.items.add(file)
          })
          emit('wrong-format', wrongFormatFiles)
        }
      }

      dragover.value = false
      emit('input', files.value)
    }

    const onDeleteFile = (fileIndex: number) => {
      const newFileList = [...files.value].filter(
        (_, index) => index !== fileIndex
      )
      files.value = newFileList
      emit('input', newFileList)
    }

    const onFocus = () => {
      isFocus.value = true
      emit('focus')
    }

    const onBlur = () => {
      if (isFocus.value) {
        isFocus.value = false
        emit('blur')
      }
    }

    const getFilePreviewIconName = (type: string) => {
      if (type.includes('image')) return 'icon/preview-image'
      return 'icon/preview-default'
    }

    return {
      files,
      dragover,
      filesToDisplay,
      isMaxCountLimitExceeded,
      onInput,
      onDragOver,
      onDragLeave,
      onDrop,
      onFocus,
      onBlur,
      onDeleteFile,
      getFilePreviewIconName,
    }
  },
})
